var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrTableDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.02,
    height: 30,
    viewBox: "0 0 30.02 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41780",
    "data-name": "Group 41780",
    transform: "translate(-17679 21891.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41749",
    "data-name": "Group 41749",
    transform: "translate(17679 -21891.668)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3129",
    "data-name": "Ellipse 3129",
    cx: 15.01,
    cy: 15,
    rx: 15.01,
    ry: 15,
    transform: "translate(0 0.168)",
    fill: "#14b7dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41750",
    "data-name": "Group 41750",
    transform: "translate(17686.928 -21883.584)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75908",
    "data-name": "Rectangle 75908",
    width: 3.283,
    height: 16.749,
    transform: "translate(0.001 2.322) rotate(-45)",
    fill: "#76747f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75909",
    "data-name": "Rectangle 75909",
    width: 16.749,
    height: 3.283,
    transform: "translate(0 11.843) rotate(-45)",
    fill: "#76747f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrTableDeleteIcon);
export default __webpack_public_path__ + "static/media/TRTableDeleteIcon.efac2d541c059809d3b66f67a47f3a48.svg";
export { ForwardRef as ReactComponent };